import { Injectable, inject } from '@angular/core';
import { StorageService } from '@seu-services';

@Injectable({
  providedIn: 'root',
})
export class NestedSolutionService {
  private readonly storageService = inject(StorageService);

  private getStoredMap(): Record<string, string> {
    return (
      this.storageService.getSessionItem<Record<string, string>>(
        'results-nested-solution'
      ) ?? {}
    );
  }

  public getSelectedSolution(compositeKey: string): string | undefined {
    return this.getStoredMap()[compositeKey];
  }

  public setSelectedSolution(compositeKey: string, value: string): void {
    const map = this.getStoredMap();
    map[compositeKey] = value;
    this.storageService.setSessionItem('results-nested-solution', map);
  }

  public clearSelectedSolution(compositeKey: string): void {
    const map = this.getStoredMap();
    delete map[compositeKey];
    this.storageService.setSessionItem('results-nested-solution', map);
  }
}
